export default __webpack_public_path__ + "static/media/tips-image.c78cb468.png";